const FOUR_DIGIT_YEAR = /^\d{4}$/;
const MIN_YEAR = 1900;
const MAX_YEAR = 2100;

export const GRADUATION_YEAR_ERROR = 'Enter a four-digit year between 1900 and 2100.';

/**
 * Empty clears the applied year filter. Anything else must be a four-digit integer in 1900–2100.
 * Callers must not write the filter when this returns false.
 */
export function isValidGraduationYearFilter(value: string): boolean {
    return value === '' || (FOUR_DIGIT_YEAR.test(value) && Number(value) >= MIN_YEAR && Number(value) <= MAX_YEAR);
}
